import { NEWS_FEEDS } from "../../../shared/feeds";
import type { TickerSettings } from "../../../shared/models";
import { useHousehold } from "../../app/useHousehold";
import { useTicker, useUpdateSettings } from "../../data/queries";

const ITEMS: { key: keyof Omit<TickerSettings, "newsFeed">; label: string }[] = [
  { key: "news", label: "News headlines" },
  { key: "onThisDay", label: "On this day (family-friendly picks)" },
  { key: "quote", label: "Quote of the day" },
  { key: "joke", label: "Joke of the day" },
  { key: "word", label: "Word of the day" },
  { key: "fact", label: "Fun fact" },
];

export function TickerSection() {
  const { settings, isAdmin } = useHousehold();
  const update = useUpdateSettings();
  const ticker = useTicker();
  const t = settings.ticker;
  const set = (patch: Partial<TickerSettings>) => update.mutate({ ticker: { ...t, ...patch } }, { onSuccess: () => void ticker.refetch() });

  return (
    <div className="form">
      <h3>Home ticker</h3>
      <p className="muted">A slim line at the bottom of Home and Morning that rotates through today’s items. Tap it on the wall to see them all.</p>
      {ITEMS.map((i) => (
        <label key={i.key} className="field field-toggle">
          <span>{i.label}</span>
          <input type="checkbox" className="switch" checked={t[i.key]} disabled={!isAdmin} onChange={(e) => set({ [i.key]: e.target.checked })} />
        </label>
      ))}
      <div className="field">
        <span>Headlines from</span>
        <div className="chip-row wrap">
          {NEWS_FEEDS.map((f) => (
            <button key={f.url} className={`chip ${t.newsFeed === f.url ? "on" : ""}`} disabled={!isAdmin || !t.news} onClick={() => set({ newsFeed: f.url })}>
              {f.name}
            </button>
          ))}
        </div>
      </div>
      <h4>Today</h4>
      <ul className="ticker-preview">
        {(ticker.data?.items ?? []).map((it, n) => (
          <li key={n}>
            <strong>{it.label}</strong> {it.text} {it.detail && <span className="muted">{it.detail}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
